import BusinessTable from "./BusinessTable";

export default BusinessTable;
